import { linkResolver } from 'prismic/linkResolver';
import { motion, useAnimationControls, Variants } from 'framer-motion';
import { LightningIcon } from './LightningIcon';

import { Link } from 'components/link/Link';

import styles from './LightningButton.module.scss';
import { SpringTransition } from './constants';
import { PrismicLinkWithMeta } from 'prismic/types/link';
import cx from 'classnames';

interface LightningButtonProps {
  link: PrismicLinkWithMeta | string | undefined;
  text?: string;
  metaUid?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  isSmall?: boolean;
  disabled?: boolean;
}

export const lightningRotationVariants: Variants = {
  hover: {
    rotate: 0,
    transition: SpringTransition,
    scale: 1.45,
  },
  initial: {
    rotate: 180,
    transition: SpringTransition,
    scale: 1,
  },
};

const LightningButton = (props: LightningButtonProps) => {
  const {
    link,
    text,
    children,
    onClick,
    isSmall = false,
    disabled = false,
  } = props;
  const lightningRotation = useAnimationControls();

  const url = linkResolver(link);

  const buttonContent = (
    <>
      <div className={styles.backgroundGradient} />

      <span className={styles.buttonTextLarge}>
        <motion.div
          animate={lightningRotation}
          variants={lightningRotationVariants}
          initial="initial"
          className={styles.lightningWrapper}
        >
          <LightningIcon className={styles.lightningIcon} />
        </motion.div>
        {children ? children : text}
      </span>
    </>
  );

  //**If link is undefined we treat it as a button */
  return link ? (
    <Link
      to={url}
      className={cx(styles.lightningButton, { [styles.buttonSmall]: isSmall })}
      onMouseEnter={() => {
        lightningRotation.start('hover');
      }}
      onMouseLeave={() => {
        lightningRotation.start('initial');
      }}
      onClick={onClick}
    >
      {buttonContent}
    </Link>
  ) : (
    <button
      className={styles.lightningButton}
      disabled={disabled}
      onMouseEnter={() => {
        lightningRotation.start('hover');
      }}
      onMouseLeave={() => {
        lightningRotation.start('initial');
      }}
      onClick={onClick}
    >
      {buttonContent}
    </button>
  );
};
export default LightningButton;
